/**
 * Amasty Multiple Wishlist compatibility for ScandiPWA
 * @copyright Scandiweb, Inc. All rights reserved.
 */

import getStore from 'Util/Store';

export const addShareOptions = (args, callback) => {
    const socialNetworks = getStore().getState().ConfigReducer?.amastyMWishlistConfig?.socialNetworks;
    const isEnabled = getStore().getState().ConfigReducer?.amastyMWishlistConfig?.isEnabled;

    // if (!isEnabled || !socialNetworks?.length) {
    //     return callback(...args);
    // }

    return null;
};

export default {
    'Component/Header/Component': {
        'member-function': {
            renderShareWishListButton: addShareOptions
        }
    }
};
